/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyticsImportAggrSectionScores
 */
export interface AnalyticsImportAggrSectionScores {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsImportAggrSectionScores
     */
    contactImportId: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsImportAggrSectionScores
     */
    promptGroupName: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsImportAggrSectionScores
     */
    scorePercentage: string;
}


/**
 * Check if a given object implements the AnalyticsImportAggrSectionScores interface.
 */
export function instanceOfAnalyticsImportAggrSectionScores(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactImportId" in value;
    isInstance = isInstance && "promptGroupName" in value;
    isInstance = isInstance && "scorePercentage" in value;

    return isInstance;
}

export function AnalyticsImportAggrSectionScoresFromJSON(json: any): AnalyticsImportAggrSectionScores {
    return AnalyticsImportAggrSectionScoresFromJSONTyped(json, false);
}

export function AnalyticsImportAggrSectionScoresFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyticsImportAggrSectionScores {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactImportId': json['contactImportId'],
        'promptGroupName': json['promptGroupName'],
        'scorePercentage': json['scorePercentage'],
    };
}

export function AnalyticsImportAggrSectionScoresToJSON(value?: AnalyticsImportAggrSectionScores | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactImportId': value.contactImportId,
        'promptGroupName': value.promptGroupName,
        'scorePercentage': value.scorePercentage,
    };
}

